import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import LeadCancelled from './icon-lead-cancelled.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <LeadCancelled {...validProps} />;
}
SvgComponent.iconName = 'leadCancelled';

/**
 * @deprecated This is a legacy icon
 */
export const LeadCancelledIcon = svgIconWrapper(SvgComponent);
